module.exports = __webpack_public_path__ + "static/media/V-img6.9aeb616d.png";